import { useCallback } from "react";
import useWorkspaces from "./useWorkspaces";
import buildSettingsItemUrl from "../Utils/buildSettingsItemUrl";

/**
 * Returns a `chipHref(option)` function that builds the settings deep-link for
 * a given chip's entity (`/workspaces/<id>/settings/<section>/<entityId>`).
 *
 * `option` is the react-select value object shaped `{ value, label }` (the
 * entity id lives in `.value`); falls back to `.id` for non-select callers.
 *
 * @param {string} sectionUid - e.g. "AUTHORISATIONS"
 * @returns {(option: object) => string|null}
 */
const useSettingsChipHref = (sectionUid) => {
  const { getActiveWorkspace } = useWorkspaces();
  const workspaceId = getActiveWorkspace?.()?.id;
  return useCallback(
    (item) =>
      buildSettingsItemUrl(workspaceId, sectionUid, item?.value || item?.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [workspaceId, sectionUid],
  );
};

export default useSettingsChipHref;